import {Component, Prop, Vue} from 'vue-property-decorator';
import debounce from "debounce";

@Component<RequestSearchInput>({})
export default class RequestSearchInput extends Vue {
  @Prop()
  protected value!: string;

  public searchDebounce: Function = this.handleSearch();

  protected handleSearch() {
    return debounce((search: string) => {
      this.$emit('input', search);
    }, 400);
  }

  protected handleInput(search: string): void {
    this.searchDebounce(search);
  }
}
